const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}

const wrapText = (ctx, text, maxWidth) => {
  const words = text.split(' ')
  const lines = []
  let currentLine = words[0]

  for (let i = 1; i < words.length; i++) {
    const word = words[i]
    const width = ctx.measureText(currentLine + ' ' + word).width
    if (width < maxWidth) {
      currentLine += ' ' + word
    } else {
      lines.push(currentLine)
      currentLine = word
    }
  }
  lines.push(currentLine)
  return lines
}

export const generateA4Image = async (data) => {
  const canvas = document.createElement('canvas')
  canvas.width = 2100
  canvas.height = 1487
  const ctx = canvas.getContext('2d')

  // Fundo com cor suave
  ctx.fillStyle = '#f8fafC'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  // Retângulo superior
  ctx.fillStyle = '#1b229f'
  ctx.fillRect(0, 0, canvas.width, 180)

  // Carregar e adicionar logo white no fundo azul (centralizada)
  try {
    const logo = await loadImage('/images/logo-white.png')
    const logoHeight = 100
    const logoWidth = (logo.width / logo.height) * logoHeight
    ctx.drawImage(logo, (canvas.width - logoWidth) / 2, (180 - logoHeight) / 2, logoWidth, logoHeight)
  } catch (error) {
    console.error('Erro ao carregar logo:', error)
  }

  // Box principal com borda arredondada
  ctx.fillStyle = '#ffffff'
  ctx.strokeStyle = '#1b229f'
  ctx.lineWidth = 4
  const boxX = 140
  const boxY = 230
  const boxWidth = canvas.width - 280
  const boxHeight = 1040
  const radius = 20

  ctx.beginPath()
  ctx.moveTo(boxX + radius, boxY)
  ctx.lineTo(boxX + boxWidth - radius, boxY)
  ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius)
  ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius)
  ctx.quadraticCurveTo(boxX + boxWidth, boxY + boxHeight, boxX + boxWidth - radius, boxY + boxHeight)
  ctx.lineTo(boxX + radius, boxY + boxHeight)
  ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius)
  ctx.lineTo(boxX, boxY + radius)
  ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY)
  ctx.closePath()
  ctx.fill()
  ctx.stroke()

  // Paciente
  ctx.fillStyle = '#646464'
  ctx.font = 'bold 50px Arial, sans-serif'
  ctx.textAlign = 'left'
  ctx.fillText('PACIENTE:', boxX + 60, boxY + 100)

  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 85px Arial, sans-serif'
  ctx.textAlign = 'center'
  ctx.fillText(data.name.toUpperCase(), canvas.width / 2, boxY + 210)

  // Linha divisória
  ctx.strokeStyle = '#dcdcdc'
  ctx.lineWidth = 2
  ctx.beginPath()
  ctx.moveTo(boxX + 60, boxY + 250)
  ctx.lineTo(boxX + boxWidth - 60, boxY + 250)
  ctx.stroke()

  // Diagnóstico
  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 48px Arial, sans-serif'
  ctx.textAlign = 'left'
  ctx.fillText('DIAGNÓSTICO:', boxX + 60, boxY + 330)

  ctx.fillStyle = '#3c3c3c'
  ctx.font = '42px Arial, sans-serif'
  ctx.fillText('Após intenso tratamento educacional, conduzido pela equipe do Aprova Total, ', boxX + 60, boxY + 400)
  ctx.fillText('o(a) paciente apresentou evolução nas áreas do conhecimento e redação.', boxX + 60, boxY + 460)

  // Prescrição
  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 48px Arial, sans-serif'
  ctx.fillText('PRESCRIÇÃO:', boxX + 60, boxY + 560)

  ctx.fillStyle = '#3c3c3c'
  ctx.font = '42px Arial, sans-serif'
  const prescriptions = [
    '- Dose diária de confiança',
    '- Foco durante a prova',
    '- Tomar 1 comprimido de autoconfiança antes de sair de casa e durante a prova.',
    '- Usar o comprimido Foco a cada questão, lendo primeiro o comando.',
    '- Respirar profundamente nos momentos de tensão ou cansaço.',
    '- Ingerir a pílula Autocontrole em casos de nervosismo.',
    '- Consumir pílulas de confiança, quantas vezes forem necessárias durante o exame.',
    '- Pingar gotas de calma (sublingual)antes de abrir o caderno de prova.',
    '- Injeção de coragem ao ler o enunciado da questão difícil.',
    '- Tomar xarope de otimismo em caso de dúvida.',
    '- Aplicar o antídoto contra branco na mente: respire e releia o comando, senão pule a questão.',
    '- Hidratar constantemente e levar lanche leve e energético.',
    '- Tomar soro de autocompaixão em caso de dúvidas.',
    '- Alimentar-se bem e dormir cedo na noite anterior da prova.',
    '- Planejar rota até o local de prova e horário de saída de casa (evite atrasos).',
    '- Fazer checkup na separação de documento original e cartão de confirmação.',
    '- Levar caneta preta reserva, em caso de emergência.',
    '- Usar roupas confortáveis e máscara do foco total na prova.',
    '- Evitar comparações: cada paciente tem seu tempo de cura.',
  ]
  prescriptions.forEach((item, index) => {
    ctx.fillText(item, boxX + 60, boxY + 630 + (index * 60))
  })

  // Resultado
  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 52px Arial, sans-serif'
  ctx.textAlign = 'center'
  ctx.fillText('RESULTADO: APTO(A) PARA O ENEM 2025!', canvas.width / 2, boxY + 800)

  // Rodapé
  ctx.fillStyle = '#f5f5fa'
  ctx.fillRect(0, canvas.height - 180, canvas.width, 180)

  const currentDate = new Date().toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  })

  ctx.fillStyle = '#646464'
  ctx.font = '35px Arial, sans-serif'
  ctx.textAlign = 'left'
  ctx.fillText(`Data de Alta: ${currentDate}`, 140, canvas.height - 110)
  ctx.fillText(`Contato: ${data.email} | ${data.whatsapp}`, 140, canvas.height - 60)

  // Assinatura
  ctx.strokeStyle = '#1b229f'
  ctx.lineWidth = 2
  ctx.beginPath()
  ctx.moveTo(canvas.width - 800, canvas.height - 95)
  ctx.lineTo(canvas.width - 140, canvas.height - 95)
  ctx.stroke()

  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 35px Arial, sans-serif'
  ctx.textAlign = 'center'
  ctx.fillText('Dr. Aprova - CRM: Confiança Renovada e Motivação', canvas.width - 470, canvas.height - 60)

  return canvas.toDataURL('image/png')
}

export const generateStoriesImage = async (data, week) => {
  const canvas = document.createElement('canvas')
  canvas.width = 1080
  canvas.height = 1920
  const ctx = canvas.getContext('2d')

  // Fundo com cor suave
  ctx.fillStyle = '#f8fafc'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  // Retângulo superior
  ctx.fillStyle = '#1b229f'
  ctx.fillRect(0, 0, canvas.width, 200)

  // Carregar e adicionar logo white no fundo azul (centralizada)
  try {
    const logo = await loadImage('/images/logo-white.png')
    const logoHeight = 110
    const logoWidth = (logo.width / logo.height) * logoHeight
    ctx.drawImage(logo, (canvas.width - logoWidth) / 2, (200 - logoHeight) / 2, logoWidth, logoHeight)
  } catch (error) {
    console.error('Erro ao carregar logo:', error)
  }

  // Box principal
  ctx.fillStyle = '#ffffff'
  ctx.strokeStyle = '#1b229f'
  ctx.lineWidth = 3
  const boxX = 60
  const boxY = 250
  const boxWidth = canvas.width - 120
  const boxHeight = 1440
  const radius = 20

  ctx.beginPath()
  ctx.moveTo(boxX + radius, boxY)
  ctx.lineTo(boxX + boxWidth - radius, boxY)
  ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius)
  ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius)
  ctx.quadraticCurveTo(boxX + boxWidth, boxY + boxHeight, boxX + boxWidth - radius, boxY + boxHeight)
  ctx.lineTo(boxX + radius, boxY + boxHeight)
  ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius)
  ctx.lineTo(boxX, boxY + radius)
  ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY)
  ctx.closePath()
  ctx.fill()
  ctx.stroke()

  // Paciente
  ctx.fillStyle = '#646464'
  ctx.font = 'bold 32px Arial, sans-serif'
  ctx.textAlign = 'left'
  ctx.fillText('PACIENTE:', boxX + 40, boxY + 80)

  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 48px Arial, sans-serif'
  ctx.textAlign = 'center'

  // Wrap do nome se for muito longo
  const nameLines = wrapText(ctx, data.name.toUpperCase(), boxWidth - 80)
  nameLines.forEach((line, index) => {
    ctx.fillText(line, canvas.width / 2, boxY + 160 + (index * 55))
  })

  const nameHeight = nameLines.length * 55
  const afterNameY = boxY + 160 + nameHeight

  // Linha divisória
  ctx.strokeStyle = '#dcdcdc'
  ctx.lineWidth = 2
  ctx.beginPath()
  ctx.moveTo(boxX + 40, afterNameY + 20)
  ctx.lineTo(boxX + boxWidth - 40, afterNameY + 20)
  ctx.stroke()

  // Diagnóstico
  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 32px Arial, sans-serif'
  ctx.textAlign = 'left'
  ctx.fillText('DIAGNÓSTICO:', boxX + 40, afterNameY + 90)

  ctx.fillStyle = '#3c3c3c'
  ctx.font = '26px Arial, sans-serif'
  const diagLines = wrapText(
    ctx,
    'Após intenso tratamento educacional, conduzido pela equipe do Aprova Total, o(a) paciente apresentou evolução nas áreas do conhecimento e redação.',
    boxWidth - 80
  )
  diagLines.forEach((line, index) => {
    ctx.fillText(line, boxX + 40, afterNameY + 140 + (index * 35))
  })

  const diagHeight = diagLines.length * 35
  const afterDiagY = afterNameY + 140 + diagHeight

  // Prescrição
  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 32px Arial, sans-serif'
  ctx.fillText('PRESCRIÇÃO:', boxX + 40, afterDiagY + 60)

  ctx.fillStyle = '#3c3c3c'
  ctx.font = '20px Arial, sans-serif'
  const prescriptions = [
    '- Dose diária de confiança',
    '- Foco durante a prova',
    '- Tomar 1 comprimido de autoconfiança antes de sair de casa e durante a prova.',
    '- Usar o comprimido Foco a cada questão, lendo primeiro o comando.',
    '- Respirar profundamente nos momentos de tensão ou cansaço.',
    '- Ingerir a pílula Autocontrole em casos de nervosismo.',
    '- Consumir pílulas de confiança, quantas vezes forem necessárias durante o exame.',
    '- Pingar gotas de calma (sublingual)antes de abrir o caderno de prova.',
    '- Injeção de coragem ao ler o enunciado da questão difícil.',
    '- Tomar xarope de otimismo em caso de dúvida.',
    '- Aplicar o antídoto contra branco na mente: respire e releia o comando, senão pule a questão.',
    '- Hidratar constantemente e levar lanche leve e energético.',
    '- Tomar soro de autocompaixão em caso de dúvidas.',
    '- Alimentar-se bem e dormir cedo na noite anterior da prova.',
    '- Planejar rota até o local de prova e horário de saída de casa (evite atrasos).',
    '- Fazer checkup na separação de documento original e cartão de confirmação.',
    '- Levar caneta preta reserva, em caso de emergência.',
    '- Usar roupas confortáveis e máscara do foco total na prova.',
    '- Evitar comparações: cada paciente tem seu tempo de cura.',
  ]
  prescriptions.forEach((item, index) => {
    ctx.fillText(item, boxX + 40, afterDiagY + 110 + (index * 40))
  })

  // Resultado
  ctx.fillStyle = '#1b229f'
  ctx.font = 'bold 34px Arial, sans-serif'
  ctx.textAlign = 'center'
  const resultLines = wrapText(ctx, `RESULTADO: APTO(A) PARA O DIA ${week} DO ENEM 2025!`, boxWidth - 80)
  resultLines.forEach((line, index) => {
    ctx.fillText(line, canvas.width / 2, boxY + boxHeight - 50 + (index * 40))
  })

  // Rodapé
  ctx.fillStyle = '#f5f5fa'
  ctx.fillRect(0, canvas.height - 160, canvas.width, 160)

  const currentDate = new Date().toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  })

  ctx.fillStyle = '#646464'
  ctx.font = '24px Arial, sans-serif'
  ctx.textAlign = 'center'
  ctx.fillText(`Data de Alta: ${currentDate}`, canvas.width / 2, canvas.height - 100)

  // Assinatura
  ctx.font = 'bold 26px Arial, sans-serif'
  ctx.fillStyle = '#1b229f'
  ctx.fillText('Dr. Aprova', canvas.width / 2, canvas.height - 50)
  ctx.font = '22px Arial, sans-serif'
  ctx.fillText('CRM: Confiança Renovada e Motivação', canvas.width / 2, canvas.height - 20)

  return canvas.toDataURL('image/png')
}
